import { render, staticRenderFns } from "./PageEditorContentSettings.vue?vue&type=template&id=14714957&scoped=true"
import script from "./PageEditorContentSettings.vue?vue&type=script&lang=js"
export * from "./PageEditorContentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14714957",
  null
  
)

export default component.exports